export default __webpack_public_path__ + "static/media/fj.86131889.svg";